import {useEffect, useState} from 'react'
import {Form} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import Select from 'react-select'
import {processGet} from '../../../services/api'

export const ServerFilter = (props: any) => {
  const intl = useIntl()
  const forceSelection = props.forceSelection || false
  let defaultServerValue = forceSelection ? 'oneormore' : 'all'
  const [server, setServer] = useState(defaultServerValue)
  const [groups, setGroups] = useState([])
  const [group_selected, setGroupSelected] = useState<any>(null)
  const [servers, setServers] = useState([])
  const [servers_selected, setServersSelected] = useState<any>([])

  useEffect(() => {
    const fetchGroups = async () => {
      let grps: any = await processGet('system-settings/server-groups/all')
      setGroups(grps.data)
    }
    fetchGroups()
  }, [])
  useEffect(() => {
    const fetchServers = async () => {
      let srvs: any = await processGet(
        'system-settings/server-groups/' + group_selected.value + '/servers'
      )
      setServers(srvs.data)
    }
    if (!group_selected) {
      setServers([])
      return
    }
    fetchServers()
  }, [group_selected])

  useEffect(() => {
    props.onChangedServer?.(server)
  }, [props, server])

  useEffect(() => {
    props.onChangedServersSelected?.(servers_selected)
  }, [props, servers_selected])

  useEffect(() => {
    props.onGroupSelected?.(group_selected)
  }, [props, group_selected])

  return (
    <>
      <div className='row mb-3'>
        <div className='col-12'>
          <label htmlFor='date_range' className='fw-bold fs-6'>
            {intl.formatMessage({
              id: 'GENERIC.SERVER_OF_INTEREST',
            })}
          </label>
          {!forceSelection && (
            <>
              <Form.Check
                type='radio'
                id='all_server'
                value='all'
                label={intl.formatMessage({
                  id: 'GENERIC.ALL_SERVERS',
                })}
                checked={server === 'all'}
                onChange={(e) => setServer(e.target.value)}
                className='mb-2'
              />
              <Form.Check
                type='radio'
                id='oneormore_server'
                value='oneormore'
                label={intl.formatMessage({
                  id: 'GENERIC.ONE_OR_MORE_SERVERS',
                })}
                checked={server === 'oneormore'}
                className='mb-2'
                onChange={(e) => setServer(e.target.value)}
              />
            </>
          )}
        </div>
      </div>

      {server === 'oneormore' && (
        <>
          <div className='row mb-3'>
            <label htmlFor='date_range' className='required fw-bold fs-6'>
              {intl.formatMessage({
                id: 'GENERIC.SELECT_SERVER_GROUPS',
              })}
            </label>
            <div className='col-12'>
              <Select
                name='server_group'
                options={groups.map((cat: any) => ({
                  value: cat.id,
                  label: cat.group_name,
                }))}
                classNamePrefix='select'
                onChange={(selectedOption) => {
                  setGroupSelected(selectedOption)
                }}
                value={group_selected}
              />
            </div>
          </div>

          <div className='row mb-3'>
            <label htmlFor='date_range' className=' fw-bold fs-6'>
              {intl.formatMessage({
                id: 'GENERIC.SELECT_SERVERS',
              })}
            </label>
            <div className='col-12'>
              <Select
                isMulti={true}
                name='setServersSelected'
                options={servers.map((cat: any) => ({
                  value: cat.id,
                  label: cat.server_name,
                }))}
                classNamePrefix='select'
                onChange={(selectedOption) => {
                  setServersSelected(selectedOption)
                }}
                value={servers_selected}
              />
            </div>
          </div>
        </>
      )}
    </>
  )
}
